import { UserPanel } from '../types/bloodWork'

/**
 * Check if a lab panel requires provocation type selection
 * @param panel - The panel to check
 * @returns true if the panel requires provocation type
 */
export const isPanelRequiringProvocation = (panel: UserPanel): boolean => {
  return panel.requiresProvocationType === true
}

/**
 * Check if a panel has any test results filled in
 * @param panel - The panel to check
 * @returns true if any item in the panel has a non-empty result
 */
export const isPanelFilledOut = (panel: UserPanel): boolean => {
  return (
    panel.items?.some((item) => {
      if (!item.result) return false
      const resultStr = String(item.result).trim()
      return resultStr !== ''
    }) ?? false
  )
}

/**
 * Normalize provocation type value to array format
 * Handles backward compatibility with string values
 * @param value - The provocation type value (string, array, or undefined)
 * @returns Normalized array or undefined
 */
export const normalizeProvocationType = (
  value: string | string[] | undefined
): string[] | undefined => {
  if (!value) return undefined
  if (Array.isArray(value)) return value.length > 0 ? value : undefined
  return [value]
}

/**
 * Check if provocation type is valid (not empty)
 * @param value - The provocation type value (string, array, or undefined)
 * @returns true if value exists and is not empty
 */
export const isProvocationTypeValid = (
  value: string | string[] | undefined
): boolean => {
  if (!value) return false
  if (Array.isArray(value)) return value.length > 0
  return value.trim() !== ''
}
